import { TestSurface } from './types'

export const TESTS = {
  'woo-cart-in-navigation': {
    variants: {
      control: 0, // 0% of users will see the old behavior
      test: 100 // 100% of users will see the new behavior
    },
    controlVariant: 'control',
    testSurfaces: [TestSurface.OOV4, TestSurface.CUSTOM_DOMAINS],
    disabled: false
  },
  'woo-reorder-authentication': {
    variants: {
      control: 100,
      test: 0
    },
    controlVariant: 'control',
    testSurfaces: [
      TestSurface.OOV4,
      TestSurface.CUSTOM_DOMAINS,
      TestSurface.TOAST_LOCAL
    ],
    disabled: false
  },
  'oo-menu-cache-first': {
    variants: {
      control: 100,
      test: 0
    },
    controlVariant: 'control',
    testSurfaces: [
      TestSurface.OOV4,
      TestSurface.CUSTOM_DOMAINS,
      TestSurface.TOAST_LOCAL
    ],
    disabled: false,
    launchDarklyFlag: 'ooMenuCacheFirst'
  }
}
